import { render, staticRenderFns } from "./TaraPayrollCard.vue?vue&type=template&id=7523d4ec&scoped=true"
import script from "./TaraPayrollCard.vue?vue&type=script&lang=js"
export * from "./TaraPayrollCard.vue?vue&type=script&lang=js"
import style0 from "./TaraPayrollCard.vue?vue&type=style&index=0&id=7523d4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7523d4ec",
  null
  
)

export default component.exports